import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useGlobalState } from "../globalState/GlobalStateProvider";
import menuItems from "../../content/menuItems";
import MenuItem from "./MenuItem";
import './Sidebar.css';

const Sidebar = () => {
  const { pathname: currentPath } = useLocation();
  const dividedMenuItems = ["dispatchers", "carriers", "configurations"];
  const {state} = useGlobalState();

  const sidebarRef = useRef<HTMLDivElement>(null);

  const handleIsActive = (url: string) => {
     //const reg = new RegExp(currentPath.split('\/')[currentPath.split('\/').length - 1], g);
     const isActive = currentPath.split('/')[currentPath.split('/').length - 1] === url.split('/')[url.split('/').length - 1];
     return isActive;
  };

  const userPermissions = useMemo(() => { 
    const result : string[] = state.user.funcoes;
    return result;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasPermission = (permissionName:string) => {
    const has = userPermissions.includes(permissionName);
    
    return has;
  };

  const filteredMenuItems = useMemo(() => {
    let hasDivider = false;
    const filtered = menuItems
      .filter((item) => !item.permission || hasPermission(item.permission))
      .map((item) => {
        if (dividedMenuItems.includes(item.label) && !hasDivider) {
          item.hasDivider = true;
          hasDivider = true;
        }

        return item;
      });
      
    return filtered;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPermissions]);

  // A Sidebar é persistente (vive no MainLayout), então o scroll é preservado ao
  // navegar. Só ajustamos quando o item ativo não está totalmente visível.
  useEffect(() => {
    const container = sidebarRef.current;
    if (!container) return;

    const activeLink = container.querySelector<HTMLElement>("menu li a.active");
    if (!activeLink) return;

    const target = (activeLink.closest("li") as HTMLElement | null) ?? activeLink;

    const viewTop = container.scrollTop;
    const viewBottom = viewTop + container.clientHeight;
    const itemTop = target.offsetTop;
    const itemBottom = itemTop + target.offsetHeight;

    // Já totalmente visível: não mexe no scroll.
    if (itemTop >= viewTop && itemBottom <= viewBottom) return;

    const partiallyVisible = itemBottom > viewTop && itemTop < viewBottom;
    const top = partiallyVisible
      ? (itemTop < viewTop ? itemTop : itemBottom - container.clientHeight) // vizinho: anda o mínimo
      : itemTop - (container.clientHeight - target.offsetHeight) / 2;        // fora da tela: centraliza
    container.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
  }, [currentPath, filteredMenuItems]);

  return (
    <div
      id="interface-sidebar"
      ref={sidebarRef}
      className={!!state?.sidebarOpen ? "opened" : "closed"}
    >
      <menu>
        {filteredMenuItems.map((item) => (
          <MenuItem
            key={item.url}
            isActive={handleIsActive(item.url)}
            {...{ item }}
          />
        ))}
      </menu>
    </div>
  );
};

export default Sidebar;
